import React, { memo, useEffect, useMemo, useState, } from 'react';
import { ColorTokens, IconSizeTokens, IconTokens, RadioPropsDLSType, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import { Pressable, View } from 'react-native';
import { IconSizeTokensMap } from '@voltmoney/theme/lib/light-mobile/icons';
import { RadioDLS } from "./RadioDLS";
/**
 * Primary UI component for user interaction
 */
const Radio = ({ id, isChecked = false, onPressChecked, onPressUnChecked, size = IconSizeTokens.MD, color = ColorTokens.Primary_100, checkedIconName = IconTokens.CheckedSquare, notCheckedIconName = IconTokens.NotCheckedSquare, actionChecked, actionUnChecked, isDisabled = false, triggerAction, radioDLSType = RadioPropsDLSType.DEFAULT, sizeDLS, disabled = false }) => {
    const [isCheckedX, setChecked] = useState(isChecked);
    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked]);
    const handleAction = async () => {
        if (!isDisabled) {
            await setChecked(!isCheckedX);
            !isCheckedX
                // @ts-ignore
                ? onPressChecked && onPressChecked()
                // @ts-ignore
                : onPressUnChecked && onPressUnChecked();
            !isCheckedX &&
                actionChecked &&
                triggerAction &&
                (await triggerAction({
                    ...actionChecked,
                    payload: {
                        ...actionChecked.payload,
                        value: true,
                    },
                }));
            isCheckedX &&
                actionUnChecked &&
                triggerAction &&
                (await triggerAction({
                    ...actionUnChecked,
                    payload: {
                        ...actionUnChecked.payload,
                        value: false,
                    },
                }));
        }
    };
    if (radioDLSType !== RadioPropsDLSType.DEFAULT) {
        return React.createElement(RadioDLS, { id: id, isChecked: isChecked, onPressChecked: onPressChecked, onPressUnChecked: onPressUnChecked, size: sizeDLS || IconSizeTokens.XXL, color: color, 
            // checkedIconName = {checkedIconName}
            // notCheckedIconName = {notCheckedIconName}
            actionChecked: actionChecked, actionUnChecked: actionUnChecked, isDisabled: isDisabled, triggerAction: triggerAction, radioDLSType: radioDLSType });
    }
    const icon = useMemo(() => (React.createElement(Icon, { name: isCheckedX
            ? checkedIconName
            : notCheckedIconName, size: size, color: color })), [isCheckedX, isChecked]);
    return (React.createElement(Pressable, { disabled: disabled, onPress: handleAction, nativeID: id },
        React.createElement(View, { style: {
                height: IconSizeTokensMap[size],
                width: IconSizeTokensMap[size],
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(Icon, { name: isCheckedX
                    ? checkedIconName
                    : notCheckedIconName, size: size, color: color }))));
};
export default memo(Radio);
export { Radio };
